import axios from 'axios';
import { getAuthHeaders } from '../../../utils/auth';

// Use the same BASE_URL as the rest of the application
const BASE_URL = "https://api.lssi-fin.com";

class BiOnlineAPI {
  constructor() {
    this.client = axios.create({
      baseURL: `${BASE_URL}/api/bi-online`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  // Main Dashboard
  async getDashboard(fromDate, toDate) {
    const response = await this.client.get('/dashboard/', {
      headers: getAuthHeaders(),
      params: { from: fromDate, to: toDate }
    });
    return response.data;
  }

  // B2B Analytics
  async getB2BAnalytics(fromDate, toDate, grouping = 'daily') {
    const response = await this.client.get('/b2b-analytics/', {
      headers: getAuthHeaders(),
      params: { from: fromDate, to: toDate, grouping }
    });
    return response.data;
  }

  // B2B Trend (simplified)
  async getB2BTrend(fromDate, toDate, grouping = 'daily') {
    const response = await this.client.get('/b2b-trend/', {
      headers: getAuthHeaders(),
      params: { from: fromDate, to: toDate, grouping }
    });
    return response.data;
  }

  // Transaction Status Analytics
  async getTransactionStatus(fromDate, toDate, grouping = 'daily') {
    const response = await this.client.get('/transaction-status/', {
      headers: getAuthHeaders(),
      params: { from: fromDate, to: toDate, grouping }
    });
    return response.data;
  }

  // Companies
  async getCompanies(search = '', top = 50) {
    const response = await this.client.get('/companies/', {
      headers: getAuthHeaders(),
      params: { search, top }
    });
    return response.data;
  }

  // Company Detail
  async getCompanyDetail(domain) {
    const response = await this.client.get(`/company/${domain}/`, {
      headers: getAuthHeaders()
    });
    return response.data;
  }

  // Revenue by Value Stream
  async getRevenueByValueStream(fromDate, toDate) {
    const response = await this.client.get('/revenue-by-value-stream/', {
      headers: getAuthHeaders(),
      params: { from: fromDate, to: toDate }
    });
    return response.data;
  }

  // Sync Company Domains
  async syncCompanyDomains() {
    const response = await this.client.post('/sync-company-domains/', {}, {
      headers: getAuthHeaders()
    });
    return response.data;
  }

  // Region Analytics
  async getRegionAnalytics(fromDate, toDate) {
    const response = await this.client.get('/region-analytics/', {
      headers: getAuthHeaders(),
      params: { from: fromDate, to: toDate }
    });
    return response.data;
  }
}

export default new BiOnlineAPI();